/**
 * テーブル定義操作用メソッド 
 */


// バージョン管理用に全テーブルのメソッドをインポートする
import * as Mst001 from '@/components/00/db/Mst001'; 
import * as Mst002 from '@/components/00/db/Mst002'; 
import * as Mst003 from '@/components/00/db/Mst003';
import * as Mst004 from '@/components/00/db/Mst004';

//=================================================================
// SQLiteテーブル一覧
//=================================================================
// テーブル管理用配列
// 全てのテーブルをここに列挙する
// バージョンNoを変更するとテーブルが再作成され、データーは消去される
// 列： テーブル名、バージョンNo、テーブル新規作成用関数
export const mstTables: any = {
    'mst001': { 'ver': 1, 'func':  function(){Mst001.create()} },
    'mst002': { 'ver': 1, 'func':  function(){Mst002.create()} },
    'mst003': { 'ver': 1, 'func':  function(){Mst003.create()} },
    'mst004': { 'ver': 1, 'func':  function(){Mst004.create()} }
}
